import axios from "axios";
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import {
  LOCATION_API_PATH,
  ORDER_API_PATH,
  STORE_API_PATH,
  USER_API_PATH,
} from "../../network/config/apiPaths";
import OrdersItem from "./order-item";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { consoleLog } from "../../utils/log-utils";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
} from "reactstrap";
import { changeStatus } from "../../redux/slice/loaderSlice";
import { isAfterDate } from "../../utils/date-utils";
import { useIsFranchisLogin } from "../../utils/userRoles";
import Select from "react-select";
import { fetchUserDetails } from "../../redux/slice/formUpdateSlice";
function Orders() {
  const dispatch = useDispatch();
  const isFranchise=useIsFranchisLogin();
  const [orderResult, setOrderResult] = useState([]);

  const userDetails=useSelector(fetchUserDetails)
  const [statusList, setStatusList] = useState([
    { id: "0", name: "Pending" },
    { id: "1", name: "Accepted" },
    { id: "2", name: "Assgned" },
    { id: "3", name: "Picked-Up" },
    { id: "4", name: "Delivered" },
    { id: "6", name: "Cancelled" },
  ]);

  //Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(5);
  const [pageOffset, setPageOffset] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [filterlist, setFilterList] = useState([]);

  const [locationList, setLocationList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [foList,setFoList]=useState([]);
  const [filterForm, setFilterForm] = useState({
    status: "",
    startDate: "",
    endDate: "",
    location_name:
      selectedLocation !== null ? selectedLocation.location_name : "",
    store_id: "",
  });
  const[foId,setFoId]=useState(isFranchise==true?userDetails.userId!=""?userDetails.userId: localStorage.getItem("userId"):"")
  consoleLog("filter form", filterForm);
  consoleLog(
    "selected location",
    selectedLocation !== null ? selectedLocation.location_name : ""
  );
  const navigate = useNavigate();
  useEffect(() => {
    fetchLocation();
    fetchFo();
  }, []);

  useEffect(() => {
    StoreList();
  }, [selectedLocation]);

  useEffect(() => {
    OrderList();
  }, [filterForm,foId,selectedLocation]);

  async function OrderList() {
    if (filterForm.endDate.length > 0) {
      datesValidation();
    } else {
      makeApiCall();
    }
  }

  const makeApiCall = async () => {
    dispatch(changeStatus(true));

    // let frId = "";
    // if (isFranchise) {
    //   frId =userDetails.userId!=""?userDetails.userId: localStorage.getItem("userId");
    // }
    const data = await axios.get(
      `
      ${API_CONFIG.API_HOST}${ORDER_API_PATH.ORDER_LIST}?limit=500&offset=0&status=${filterForm.status}&fromDate=${filterForm.startDate}&toDate=${filterForm.endDate}&area=${filterForm.location_name}&storeId=${filterForm.store_id}&frId=${foId}`,
      {
        headers: API_HEADERS,
      }
    );
    dispatch(changeStatus(false));
    consoleLog("data", data.data.result);
    setOrderResult(data.data.result);
    setFilterList(data.data.result);
  };

  const handleChanges = (e) => {
    setFilterForm({ ...filterForm, [e.target.name]: e.target.value });
  };

  const datesValidation = () => {
    let to = filterForm.endDate;

    // if (new Date(formData.startDate) > new Date(to)) {
    //   alert("Select Valid Dates");
    // }

    if (
      filterForm.startDate.length > 0 &&
      filterForm.endDate.length > 0 &&
      !isAfterDate(filterForm.startDate, to)
    ) {
      alert("Select Valid Dates");
    } else {
      makeApiCall();
    }
  };

  function returnStores() {
    return (
      <>
        {storeList.map((obj, i) => {
          return <option value={obj.id}>{obj.name}</option>;
        })}
      </>
    );
  }
  const fetchLocation = async () => {
    let frId = "";
    if (isFranchise) {
      frId = userDetails.userId!=""?userDetails.userId:localStorage.getItem("userId");
    }
    let data = await axios.get(
      API_CONFIG.API_HOST +
        LOCATION_API_PATH.LOCATION_LIST_PATH +
        `foId=${frId}`,
      {
        headers: API_HEADERS,
      }
    );
    setLocationList(data.data.result);
    consoleLog("setLocationList", data.data.result);
  };

  async function StoreList() {
    if (selectedLocation !== null) {
      let apiPath =
        API_CONFIG.API_HOST +
        `Store/list?foId=${userDetails.userId!=""?userDetails.userId:localStorage.getItem("userId")}&area=${
          selectedLocation.location_name
        }`;

      const data = await axios.get(apiPath, {
        headers: API_HEADERS,
      });

      // setIsLoading(false);
      consoleLog("storeResult", data.data.result);

      setStoreList(data.data.result);
      // setResultList(data.data.result);
    }
  }

  const fetchFo=async()=>{
    let data=await axios.get(API_CONFIG.API_HOST+USER_API_PATH.LIST_PATH+"9",{
      headers:API_HEADERS
    })
    console.log("fo list....",data)
    setFoList(data.data.result)
  }
  return (
    <>
      {consoleLog("selected location", selectedLocation)}
      <main className="container-fluid dashboard">
        <div className="row m-3">
          <div className="row justify-content-around tble">
            <div className="col-6">
              <h3 className="dashboard-title">Orders</h3>
            </div>
            <div className="mr-auto col-6 text-end">
              {/* <button
                type="button"
                className="mr-auto btn btn-purple-bg"
                onClick={() => {
                 
                }}
              >
                + Add Category
              </button> */}
            </div>
          </div>
        </div>
        <div className="row m-3">
          {/* <div className="col-md-3">
            <div className="form-group">
              <label>Search</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Enter customer mobile no"
              />
            </div>
          </div> */}
          <div className="col-md-2">
            <div className="form-group">
              <label>Order Status</label>
              <select
                name="status"
                className="form-select"
                onChange={(e) => handleChanges(e)}
                value={filterForm.status}
              >
                <option value={""}>{"--Select Status--"}</option>
                {statusList &&
                  statusList.length > 0 &&
                  statusList.map((item, index) => {
                    return (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div
            className={
              filterForm.startDate.length > 0 ? "col-md-5" : "col-md-2"
            }
          >
            <Row>
              <Col>
                <FormGroup>
                  <Label for="startDate">From Date</Label>
                  <Input
                    type="date"
                    name="startDate"
                    id="startDate"
                    placeholder=""
                    value={filterForm.startDate}
                    onChange={handleChanges}
                    // min={new Date().toISOString().split("T")[0]}
                  />
                </FormGroup>
              </Col>
              {filterForm.startDate.length > 0 && (
                <Col>
                  <FormGroup>
                    <Label for="endDate">To Date</Label>
                    <Input
                      type="date"
                      name="endDate"
                      id="endDate"
                      placeholder=""
                      value={filterForm.endDate}
                      onChange={handleChanges}
                      // min={new Date().toISOString().split("T")[0]}
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>Location</label>

              <Select
                options={locationList}
                value={selectedLocation !== "" ? selectedLocation : ""}
                getOptionLabel={(option) => `${option.location_name}`}
                getOptionValue={(option) => `${option.location_name}`}
                onChange={(sOption) => {
                  setSelectedLocation(sOption);

                  setFilterForm({
                    ...filterForm,
                    location_name: sOption.location_name,
                  });
                }}

                // isMulti
              />
            </div>
          </div>
          
          <div className="col-md-2">
            <div className="form-group">
              <label>Stores</label>

              <select
                value={filterForm.store_id}
                name="store_id"
                className="form-control"
                onChange={handleChanges}
              >
                <option value={""}>{"--Select Store--"}</option>
                {returnStores()}
              </select>
            </div>
          </div>
          {
            !isFranchise&&<div className="col-md-2">
            <label>Fo</label>
             <select className="form-control" onChange={(e)=>setFoId(e.target.value)}>
              <option value={""}>{"--Select FO--"}</option>
              {
                foList.map((obj,i)=>{
                  return(
                    <option value={obj.id} key={i}>{obj.name}</option>
                  )
                })
              }
             </select>
          </div>
          }
          

          <div className="col-md-12 card-1">
            <table className="table table-striped table-bordered border-sm  mt-2">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Branch</th>
                  <th scope="col">Date & Time</th>
                  <th scope="col">Order Amount</th>
                  <th scope="col">Customer Name </th>
                  <th scope="col">Delivery Address</th>
                  <th scope="col">Coupon</th>
                  <th scope="col">Status </th>
                  <th scope="col">Payment Mode </th>
                  <th scope="col">Store Rating </th>
                  <th scope="col">D Boy Rating </th>
                </tr>
              </thead>

              <tbody>
                {filterlist && filterlist.length > 0 ? (
                  filterlist.map((obj) => {
                    return <OrdersItem order={obj} key={obj.id} />;
                  })
                ) : (
                  <>No Orders</>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </>
  );
}
export default Orders;
